import pptxgen from 'pptxgenjs';
import fetch from 'cross-fetch';
import Color from 'color';
import React from 'react';
import ReactIs from 'react-is';

var NodeTypes;
(function (NodeTypes) {
    NodeTypes["SHAPE"] = "shape";
    NodeTypes["LINE"] = "line";
    NodeTypes["TEXT_LINK"] = "text-link";
    NodeTypes["TEXT_BULLET"] = "text-bullet";
    NodeTypes["SLIDE"] = "slide";
    NodeTypes["MASTER_SLIDE"] = "master-slide";
    NodeTypes["IMAGE"] = "image";
    NodeTypes["PRESENTATION"] = "presentation";
})(NodeTypes || (NodeTypes = {}));
var TextLink = NodeTypes.TEXT_LINK;
var isTextLink = function (el) {
    return el.type === NodeTypes.TEXT_LINK;
};
var TextBullet = NodeTypes.TEXT_BULLET;
var isTextBullet = function (el) {
    return el.type === NodeTypes.TEXT_BULLET;
};
var TextFn = function () { return null; };
TextFn.prototype.isPptxTextElement = true;
TextFn.prototype.Link = TextLink;
TextFn.prototype.Bullet = TextBullet;
var Text = Object.assign(TextFn, {
    Link: TextLink,
    Bullet: TextBullet,
});
// We add a random symbol-ish to the prototype for use in isText
// For some reason a normal el.type == Text doesn't work here when
// the result is bundled
Text.prototype.isPptxTextElement = true;
var isText = function (el) {
    var _a;
    return el.type instanceof Function && ((_a = el.type.prototype) === null || _a === void 0 ? void 0 : _a.isPptxTextElement);
};
var Image = NodeTypes.IMAGE;
var isImage = function (el) {
    return el.type === NodeTypes.IMAGE;
};
var Shape = NodeTypes.SHAPE;
var isShape = function (el) {
    return el.type === NodeTypes.SHAPE;
};
var Line = NodeTypes.LINE;
var isLine = function (el) {
    return el.type === NodeTypes.LINE;
};
var Slide = NodeTypes.SLIDE;
var MasterSlide = NodeTypes.MASTER_SLIDE;
var Presentation = NodeTypes.PRESENTATION;
var isReactPPTXComponent = function (node) {
    return Object.values(NodeTypes).includes(node.type) || isText(node);
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function isReactElementOrElementArray(
// eslint-disable-next-line @typescript-eslint/ban-types
arr) {
    return React.isValidElement(arr);
}
function flattenChildren(children, keys) {
    if (keys === void 0) { keys = []; }
    return React.Children.toArray(children).reduce(function (acc, node, nodeIndex) {
        if (ReactIs.isFragment(node)) {
            acc.push.apply(acc, flattenChildren(node.props.children, keys.concat(node.key || nodeIndex)));
        }
        else {
            if (ReactIs.isElement(node)) {
                if (isReactPPTXComponent(node)) {
                    acc.push(React.cloneElement(node, {
                        key: keys.concat(String(node.key)).join("."),
                    }));
                }
                else {
                    // A component that could return/contain react-pptx components,
                    // traverse the tree some more
                    var children_1 = node.props.children;
                    if (node.type instanceof Function) {
                        children_1 = node.type(node.props);
                    }
                    acc.push.apply(acc, flattenChildren(children_1, keys.concat(node.key || nodeIndex)));
                }
            }
            else if (typeof node === "string" || typeof node === "number") {
                acc.push(node);
            }
        }
        return acc;
    }, []);
}

// Normalizer converts and normalizes JSX Presentation trees into internal nodes
var DEFAULT_FONT_SIZE = 18;
var DEFAULT_FONT_FACE = "Arial";
var normalizeHexColor = function (colorString) {
    return Color(colorString).hex().substring(1).toUpperCase();
};
var normalizeHexOrComplexColor = function (colorString) {
    var clr = Color(colorString);
    // PptxGenJs hex color don't use leading # for hex colors
    var hexColor = clr.hex().substring(1).toUpperCase();
    if (clr.alpha() === 1) {
        return hexColor;
    }
    else {
        return {
            type: "solid",
            color: hexColor,
            // Alpha is actually transparency (ie. 0=opaque, 1=fully transparent)
            alpha: 100 - Math.round(clr.alpha() * 100),
        };
    }
};
var normalizeText = function (t) {
    if (isReactElementOrElementArray(t)) {
        return flattenChildren(t).reduce(function (textParts, el) {
            if (React.isValidElement(el)) {
                var bullet_1;
                if (isTextBullet(el)) {
                    // We know the intention is for a bullet, so pass on true if no customisation required
                    var _a = el.props, children_1 = _a.children, style_1 = _a.style, rtlMode_1 = _a.rtlMode, lang_1 = _a.lang, bulletProps = __rest(_a, ["children", "style", "rtlMode", "lang"]);
                    bullet_1 = Object.keys(bulletProps).length ? bulletProps : true;
                    var normalizedChildren_1 = normalizeText(children_1);
                    var normalizedParentColor = (style_1 === null || style_1 === void 0 ? void 0 : style_1.color)
                        ? normalizeHexColor(style_1.color)
                        : undefined;
                    var parentStyle_1 = __assign(__assign({}, (style_1 || {})), { color: normalizedParentColor });
                    // Make `breakLine = false` for all child components except the last one
                    // (so every child will sit within the same bullet point)
                    var childParts = normalizedChildren_1.map(function (childPart, index) { return (__assign(__assign({ rtlMode: rtlMode_1, lang: lang_1, bullet: index === 0 ? bullet_1 : undefined }, childPart), { style: __assign(__assign({}, parentStyle_1), childPart.style), breakLine: index + 1 >= normalizedChildren_1.length })); });
                    return textParts.concat(childParts);
                }
                var link = void 0;
                if (isTextLink(el)) {
                    // props extracted here again so that ts can infer them as TextLinkProps
                    var props = el.props;
                    if ("url" in props) {
                        link = { url: props.url, tooltip: props.tooltip };
                    }
                    else if (props.slide) {
                        link = { slide: props.slide, tooltip: props.tooltip };
                    }
                }
                var _b = el.props, children = _b.children, style = _b.style, rtlMode = _b.rtlMode, lang = _b.lang;
                return textParts.concat({
                    text: children,
                    rtlMode: rtlMode,
                    lang: lang,
                    link: link,
                    style: __assign(__assign({}, (style || {})), { color: (style === null || style === void 0 ? void 0 : style.color) ? normalizeHexColor(style.color) : undefined }),
                });
            }
            else {
                return textParts.concat({
                    text: el.toString(),
                    style: {},
                });
            }
        }, []);
    }
    else if (Array.isArray(t)) {
        return t.reduce(function (prev, cur) { return prev.concat(normalizeText(cur)); }, []);
    }
    else if (["number", "string"].includes(typeof t)) {
        return [
            {
                text: t.toString(),
                style: {},
            },
        ];
    }
    else {
        throw new TypeError("Invalid TextChild found; only strings/numbers/arrays of them are accepted");
    }
};
var PERCENTAGE_REGEXP = /^\d+%$/;
var normalizeCoordinate = function (x, _default) {
    if (typeof x === "string") {
        if (!PERCENTAGE_REGEXP.test(x)) {
            throw new TypeError("\"".concat(x, "\" is invalid position; string positions must be of format '[0-9]+%'"));
        }
        return x;
    }
    else if (typeof x === "number") {
        return x;
    }
    return _default;
};
var normalizeSlideObject = function (node) {
    var _a, _b, _c, _d, _e;
    if (!node.props.style) {
        throw new TypeError("A ".concat(node.type, " object is missing style attribute"));
    }
    if (isLine(node)) {
        return {
            kind: "line",
            x1: node.props.x1,
            y1: node.props.y1,
            x2: node.props.x2,
            y2: node.props.y2,
            style: {
                color: node.props.style.color
                    ? normalizeHexColor(node.props.style.color)
                    : null,
                width: (_a = node.props.style.width) !== null && _a !== void 0 ? _a : null,
            },
        };
    }
    var _f = node.props.style, origX = _f.x, origY = _f.y, origW = _f.w, origH = _f.h;
    var normalizedCoordinates = {
        x: normalizeCoordinate(origX, 0),
        y: normalizeCoordinate(origY, 0),
        w: normalizeCoordinate(origW, 1),
        h: normalizeCoordinate(origH, 1),
    };
    if (isText(node)) {
        var style = node.props.style;
        return {
            kind: "text",
            text: node.props.children !== undefined
                ? normalizeText(node.props.children)
                : [],
            style: __assign(__assign(__assign({}, style), normalizedCoordinates), { color: style.color ? normalizeHexColor(style.color) : null, fontFace: (_b = style.fontFace) !== null && _b !== void 0 ? _b : DEFAULT_FONT_FACE, fontSize: (_c = style.fontSize) !== null && _c !== void 0 ? _c : DEFAULT_FONT_SIZE }),
        };
    }
    else if (isImage(node)) {
        return {
            kind: "image",
            src: node.props.src,
            style: __assign(__assign({}, normalizedCoordinates), { sizing: (_d = node.props.style.sizing) !== null && _d !== void 0 ? _d : null }),
        };
    }
    else if (isShape(node)) {
        return {
            kind: "shape",
            type: node.props.type,
            text: node.props.children !== undefined
                ? normalizeText(node.props.children)
                : null,
            style: __assign(__assign({}, normalizedCoordinates), { backgroundColor: node.props.style.backgroundColor
                    ? normalizeHexOrComplexColor(node.props.style.backgroundColor)
                    : null, borderColor: node.props.style.borderColor
                    ? normalizeHexColor(node.props.style.borderColor)
                    : null, borderWidth: (_e = node.props.style.borderWidth) !== null && _e !== void 0 ? _e : null }),
        };
    }
    else {
        throw new Error("unknown slide object");
    }
};
var isPresent = function (x) {
    return x !== null;
};
var normalizeSlide = function (_a) {
    var _b, _c, _d, _e, _f;
    var props = _a.props;
    var slide = {
        masterName: (_b = props.masterName) !== null && _b !== void 0 ? _b : null,
        hidden: (_c = props.hidden) !== null && _c !== void 0 ? _c : false,
        backgroundColor: ((_d = props === null || props === void 0 ? void 0 : props.style) === null || _d === void 0 ? void 0 : _d.backgroundColor)
            ? normalizeHexOrComplexColor(props.style.backgroundColor)
            : null,
        backgroundImage: (_f = (_e = props === null || props === void 0 ? void 0 : props.style) === null || _e === void 0 ? void 0 : _e.backgroundImage) !== null && _f !== void 0 ? _f : null,
        objects: [],
    };
    if (props.children) {
        slide.objects = flattenChildren(props.children)
            .map(normalizeSlideObject)
            .filter(isPresent);
    }
    return slide;
};
var normalizeMasterSlide = function (_a) {
    var _b, _c, _d;
    var props = _a.props;
    var slide = {
        name: props.name,
        backgroundColor: ((_b = props === null || props === void 0 ? void 0 : props.style) === null || _b === void 0 ? void 0 : _b.backgroundColor)
            ? normalizeHexOrComplexColor(props.style.backgroundColor)
            : null,
        backgroundImage: (_d = (_c = props === null || props === void 0 ? void 0 : props.style) === null || _c === void 0 ? void 0 : _c.backgroundImage) !== null && _d !== void 0 ? _d : null,
        objects: [],
    };
    if (props.children) {
        slide.objects = flattenChildren(props.children)
            .map(normalizeSlideObject)
            .filter(isPresent);
    }
    return slide;
};
var normalizeJsx = function (_a) {
    var _b;
    var props = _a.props;
    var pres = {
        layout: (_b = props.layout) !== null && _b !== void 0 ? _b : "16x9",
        masterSlides: {},
        slides: [],
        author: props.author,
        company: props.company,
        revision: props.revision,
        subject: props.subject,
        title: props.title,
    };
    if (props.children) {
        var children = flattenChildren(props.children);
        pres.slides = children
            .filter(function (child) { return child.type === NodeTypes.SLIDE; })
            .map(normalizeSlide);
        var masterSlides = children
            .filter(function (child) { return child.type === NodeTypes.MASTER_SLIDE; })
            .map(normalizeMasterSlide);
        pres.masterSlides = Object.fromEntries(masterSlides.map(function (slide) { return [slide.name, slide]; }));
    }
    return pres;
};

// Renderer renders normalized nodes into pptxgenjs presentations
var normalizedColorToPptxgenShapeFill = function (color) {
    return typeof color === "string" ? { color: color } : color !== null && color !== void 0 ? color : undefined;
};
var renderTextParts = function (parts) {
    var containsBullet = parts.some(function (_a) {
        var bullet = _a.bullet;
        return !!bullet;
    });
    return parts.map(function (_a) {
        var _b, _c;
        var style = _a.style, link = _a.link, part = __rest(_a, ["style", "link"]);
        var options = __assign(__assign(__assign({}, part), style), { hyperlink: link, bullet: part.bullet, color: (_b = style === null || style === void 0 ? void 0 : style.color) !== null && _b !== void 0 ? _b : undefined });
        // For a mix of bullet points and non-bullet points, we have to add
        // breakLine to all items for pptxgenjs to recognise it.
        if (containsBullet && !link) {
            options.breakLine = (_c = options.breakLine) !== null && _c !== void 0 ? _c : true;
        }
        return {
            text: part.text,
            options: options,
        };
    });
};
var renderSlideObject = function (pres, slide, object) { return __awaiter(void 0, void 0, void 0, function () {
    var style, x_1, w_1, flipH, y_1, h_1, flipV, _a, x, y, w, h, _b, color, verticalAlign, backgroundColor, style, data, req, contentType, buffer, blob, reader_1, sizing, imageWidth, imageHeight, style, shapeType, backgroundColor;
    var _c, _d, _e, _f, _g, _h, _j, _k;
    return __generator(this, function (_l) {
        switch (_l.label) {
            case 0:
                if (object.kind === "line") {
                    style = object.style;
                    flipH = void 0;
                    if (object.x1 < object.x2) {
                        x_1 = object.x1;
                        w_1 = object.x2 - x_1;
                        flipH = false;
                    }
                    else {
                        x_1 = object.x2;
                        w_1 = object.x1 - x_1;
                        flipH = true;
                    }
                    flipV = void 0;
                    if (object.y1 < object.y2) {
                        y_1 = object.y1;
                        h_1 = object.y2 - y_1;
                        flipV = false;
                    }
                    else {
                        y_1 = object.y2;
                        h_1 = object.y1 - y_1;
                        flipV = true;
                    }
                    slide.addShape("line", {
                        x: x_1,
                        y: y_1,
                        w: w_1,
                        h: h_1,
                        flipH: flipH,
                        flipV: flipV,
                        line: {
                            width: (_c = style.width) !== null && _c !== void 0 ? _c : undefined,
                            color: (_d = style.color) !== null && _d !== void 0 ? _d : undefined,
                        },
                    });
                    return [2 /*return*/];
                }
                _a = object.style, x = _a.x, y = _a.y, w = _a.w, h = _a.h;
                if (!(object.kind === "text")) return [3 /*break*/, 1];
                _b = object.style, color = _b.color, verticalAlign = _b.verticalAlign, backgroundColor = _b.backgroundColor, style = __rest(_b, ["color", "verticalAlign", "backgroundColor"]);
                slide.addText(renderTextParts(object.text), __assign(__assign({}, style), { fill: backgroundColor
                        ? normalizedColorToPptxgenShapeFill(backgroundColor)
                        : undefined, color: color !== null && color !== void 0 ? color : undefined, valign: verticalAlign, breakLine: true }));
                return [3 /*break*/, 10];
            case 1:
                if (!(object.kind === "image")) return [3 /*break*/, 9];
                data = "";
                if (!(object.src.kind === "data")) return [3 /*break*/, 2];
                data = "data:".concat(object.src[object.src.kind]);
                return [3 /*break*/, 8];
            case 2: return [4 /*yield*/, fetch(object.src[object.src.kind])];
            case 3:
                req = _l.sent();
                if (!("buffer" in req)) return [3 /*break*/, 5];
                contentType = req.headers.raw()["content-type"][0];
                return [4 /*yield*/, req.buffer()];
            case 4:
                buffer = _l.sent();
                data = "data:".concat(contentType, ";base64,").concat(buffer.toString("base64"));
                return [3 /*break*/, 8];
            case 5: return [4 /*yield*/, req.blob()];
            case 6:
                blob = _l.sent();
                reader_1 = new FileReader();
                reader_1.readAsDataURL(blob);
                return [4 /*yield*/, new Promise(function (resolve) {
                        reader_1.onloadend = function () {
                            resolve(reader_1.result);
                        };
                    })];
            case 7:
                data = _l.sent();
                _l.label = 8;
            case 8:
                sizing = void 0;
                if (object.style.sizing && object.style.sizing.fit) {
                    imageWidth = (_e = object.style.sizing.imageWidth) !== null && _e !== void 0 ? _e : (typeof w === "number" ? w : parseInt(w, 10));
                    imageHeight = (_f = object.style.sizing.imageHeight) !== null && _f !== void 0 ? _f : (typeof h === "number" ? h : parseInt(h, 10));
                    if (isNaN(imageWidth) || isNaN(imageHeight)) {
                        throw new TypeError("when using sizing.fit, width and height must be specified numerically, either in style itself or in sizing.width/height!");
                    }
                    sizing = { type: object.style.sizing.fit, w: imageWidth, h: imageHeight };
                }
                slide.addImage({
                    data: data,
                    x: x,
                    y: y,
                    w: w,
                    h: h,
                    sizing: object.style.sizing ? sizing : undefined,
                });
                return [3 /*break*/, 10];
            case 9:
                if (object.kind === "shape") {
                    style = object.style;
                    shapeType = pres.ShapeType[object.type];
                    backgroundColor = normalizedColorToPptxgenShapeFill(style.backgroundColor);
                    if (object.text) {
                        slide.addText(renderTextParts(object.text), {
                            shape: shapeType,
                            x: x,
                            y: y,
                            w: w,
                            h: h,
                            fill: backgroundColor,
                            line: {
                                size: (_g = style.borderWidth) !== null && _g !== void 0 ? _g : undefined,
                                color: (_h = style.borderColor) !== null && _h !== void 0 ? _h : undefined,
                            },
                            breakLine: true,
                        });
                    }
                    else {
                        slide.addShape(shapeType, {
                            x: x,
                            y: y,
                            w: w,
                            h: h,
                            fill: backgroundColor,
                            line: {
                                size: (_j = style.borderWidth) !== null && _j !== void 0 ? _j : undefined,
                                color: (_k = style.borderColor) !== null && _k !== void 0 ? _k : undefined,
                            },
                        });
                    }
                }
                _l.label = 10;
            case 10: return [2 /*return*/];
        }
    });
}); };
var renderSlide = function (pres, slide, node) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        slide.hidden = node.hidden;
        if (((_a = node.backgroundImage) === null || _a === void 0 ? void 0 : _a.kind) === "data") {
            slide.background = {
                data: node.backgroundImage.data,
            };
        }
        else if (((_b = node.backgroundImage) === null || _b === void 0 ? void 0 : _b.kind) === "path") {
            slide.background = {
                path: node.backgroundImage.path,
            };
        }
        else if (node.backgroundColor) {
            slide.background = __assign({}, normalizedColorToPptxgenShapeFill(node.backgroundColor));
        }
        return [2 /*return*/, Promise.all(node.objects.map(function (object) { return renderSlideObject(pres, slide, object); }))];
    });
}); };
var renderMasterSlide = function (node) { return __awaiter(void 0, void 0, void 0, function () {
    var masterSlide;
    var _a, _b;
    return __generator(this, function (_c) {
        masterSlide = {
            title: node.name,
        };
        if (((_a = node.backgroundImage) === null || _a === void 0 ? void 0 : _a.kind) === "data") {
            masterSlide.background = {
                data: node.backgroundImage.data,
            };
        }
        else if (((_b = node.backgroundImage) === null || _b === void 0 ? void 0 : _b.kind) === "path") {
            masterSlide.background = {
                path: node.backgroundImage.path,
            };
        }
        else if (node.backgroundColor) {
            masterSlide.background = normalizedColorToPptxgenShapeFill(node.backgroundColor);
        }
        else {
            masterSlide.background = { color: "FFFFFF" };
        }
        masterSlide.objects = node.objects.map(function (object) {
            if (object.kind === "shape" && object.type === "rect") {
                return {
                    rect: __assign({ x: object.style.x, y: object.style.y, w: object.style.w, h: object.style.h }, (object.style.backgroundColor && {
                        fill: { color: object.style.backgroundColor },
                    })),
                };
            }
            else {
                throw new Error("Unsupported master slide object found! Master slides only support a small subset of objects at the moment.");
            }
        });
        return [2 /*return*/, masterSlide];
    });
}); };
var PRESENTATION_METADATA_PROPS = [
    "author",
    "company",
    "revision",
    "subject",
    "title",
];
var render = function (node, opts) { return __awaiter(void 0, void 0, void 0, function () {
    var normalized, pres, layout, masterSlides, _i, masterSlides_1, masterSlide, _a, PRESENTATION_METADATA_PROPS_1, propName, metadataValue;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                normalized = normalizeJsx(node);
                pres = new pptxgen();
                layout = "LAYOUT_16x9";
                if (normalized.layout === "16x10") {
                    layout = "LAYOUT_16x10";
                }
                else if (normalized.layout === "4x3") {
                    layout = "LAYOUT_4x3";
                }
                else if (normalized.layout === "wide") {
                    layout = "LAYOUT_WIDE";
                }
                pres.layout = layout;
                return [4 /*yield*/, Promise.all(Object.values(normalized.masterSlides).map(function (masterSlideNode) {
                        return renderMasterSlide(masterSlideNode);
                    }))];
            case 1:
                masterSlides = _c.sent();
                // .. then add to presentation in order
                for (_i = 0, masterSlides_1 = masterSlides; _i < masterSlides_1.length; _i++) {
                    masterSlide = masterSlides_1[_i];
                    pres.defineSlideMaster(masterSlide);
                }
                for (_a = 0, PRESENTATION_METADATA_PROPS_1 = PRESENTATION_METADATA_PROPS; _a < PRESENTATION_METADATA_PROPS_1.length; _a++) {
                    propName = PRESENTATION_METADATA_PROPS_1[_a];
                    metadataValue = normalized[propName];
                    if (typeof metadataValue === "string") {
                        pres[propName] = metadataValue;
                    }
                }
                return [4 /*yield*/, Promise.all(normalized.slides.map(function (slideNode) {
                        var slide = pres.addSlide(__assign({}, (slideNode.masterName && { masterName: slideNode.masterName })));
                        return renderSlide(pres, slide, slideNode);
                    }))];
            case 2:
                _c.sent();
                return [2 /*return*/, pres.write({ outputType: (_b = opts === null || opts === void 0 ? void 0 : opts.outputType) !== null && _b !== void 0 ? _b : "nodebuffer" })];
        }
    });
}); };

export { Image, Line, MasterSlide, NodeTypes, Presentation, Shape, Slide, Text, isImage, isLine, isReactPPTXComponent, isShape, isText, isTextBullet, isTextLink, normalizeJsx, render };
